module.exports = __webpack_public_path__ + "img/正方形选中.aefe3833.png";